import React, {useCallback} from "react";

export function AutoFocusInput(props: any): React.JSX.Element {
    const autoFocus = useCallback((element: any) => {
        return element ? element.focus() : null
    }, [])

    return <input type="text" ref={autoFocus} {...props} />
}
